import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import {
  Elements,
  PaymentElement,
  useStripe,
  useElements
} from '@stripe/react-stripe-js';
import Loader from '../EventsList/Loader';
import { loadStripe } from '@stripe/stripe-js';
import { SITE_URL } from '../../config/index';
import { AJAX_URL, STRIPE_API_KEY } from '../../config/index';

const stripePromise = loadStripe(STRIPE_API_KEY);

export default function CheckOutForm({ paidPlan, coupon, formData }) {
  const [totalCost, setTotalCost] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState('');
  const [clientSecret, setClientSecret] = useState('');
  const [couponError, setCouponError] = useState('');

  useEffect(() => {
    setLoading(true);
    setCouponError('');
    if (paidPlan.length > 0 || coupon) {
      const fetchSecret = async () =>
        await $.ajax({
          type: 'POST',
          url: `${AJAX_URL}wl_handle_event_payment`,
          dataType: 'json',
          data: JSON.stringify({ paid_plan: paidPlan, coupon, formData }),
          contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
        }).then((r) => {
          setClientSecret(r.data.clientSecret);
          setTotalCost(r.data.orderTotal);
          if ('error' in r.data) setCouponError(r.data.error);
          setLoading(false);
        });
      fetchSecret();
    }
  }, [selectedPlan, coupon]);

  useEffect(() => {
    setSelectedPlan(paidPlan);
  }, [paidPlan]);

  return (
    <div className="container container--xl">
      <div className="grid">
        <div className="grid__col-xs-12 grid__col-sm-8">
          {clientSecret ? (
            <>
              <div className="section__header">
                <h4 className="section__header-text">Billing Information</h4>
              </div>
              <div className="payment-form__wrapper">
                {isLoading ? (
                  <div className="loader__wrapper--event-submit">
                    <Loader />
                  </div>
                ) : (
                  <>
                    <Elements
                      stripe={stripePromise}
                      options={{ clientSecret: clientSecret }}
                    >
                      <CheckOutFields
                        totalCost={totalCost}
                        coupon={coupon}
                        couponError={couponError}
                        formData={formData}
                        paidPlan={paidPlan}
                      />
                    </Elements>
                  </>
                )}
              </div>
            </>
          ) : (
            <>
              <div className="payment-form__wrapper">
                {isLoading ? (
                  <div className="loader__wrapper--event-submit">
                    <Loader />
                  </div>
                ) : (
                  <>
                    <CheckOutFieldsFree
                      totalCost={totalCost}
                      coupon={coupon}
                      couponError={couponError}
                      formData={formData}
                      paidPlan={paidPlan}
                    />
                  </>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

function CheckOutFields({
  formData,
  coupon,
  couponError,
  totalCost,
  paidPlan
}) {
  const stripe = useStripe();
  const elements = useElements();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(couponError);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsLoading(true);

    let filesList = [];
    if (formData.file !== '') filesList.push(formData.file);
    if (formData.image !== '') filesList.push(formData.image);

    // Remove files for Event Post creation, files handled individual later
    formData.image = '';
    formData.file = '';

    // Add Pain Plan meta to post for Featured Event Cron
    formData.paidPlan = paidPlan;

    formData.coupon = coupon;

    // Save the form meta
    const postID = await $.ajax({
      type: 'POST',
      url: `${AJAX_URL}post_wlSubmitEvent`,
      dataType: 'json',
      encode: true,
      data: formData,
      contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
    })
      .then((r) => {
        return r.data;
      })
      .catch((err) => console.log(err.message));

    const validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];

    // Save files to ACF & Media Library
    let error;
    let indexCount = 0;
    if (filesList.length > 0) {
      filesList.forEach(async (file) => {
        if (file.type) {
          let acfField;
          if (!validImageTypes.includes(file.type)) {
            acfField = 'event_file_attachment';
          } else {
            acfField = 'event_image';
          }

          let formData = new FormData();
          formData.append('content', 'filename');
          formData.append('source', file);
          formData.append('postID', postID);
          formData.append('acf-field', acfField);

          await $.ajax({
            type: 'POST',
            url: `${AJAX_URL}post_wlSubmitEventFiles`,
            data: formData,
            contentType: false,
            processData: false
          })
            .then((r) => {
              indexCount++;
              console.log(indexCount);
              console.log(filesList.length);
              if (indexCount >= filesList.length) {
                error = stripe.confirmPayment({
                  elements,
                  confirmParams: {
                    // thank-you.php will set event post type to 'publish' status on successful checkout
                    return_url: `${SITE_URL}/events/submit-event/thank-you/?post_id=${postID}`
                  }
                });
              }
            })
            .catch((err) => err.message);
        }
      });
    } else {
      error = stripe.confirmPayment({
        elements,
        confirmParams: {
          // thank-you.php will set event post type to 'publish' status on successful checkout
          return_url: `${SITE_URL}/events/submit-event/thank-you/?post_id=${postID}`
        }
      });
    }

    if (error.type === 'card_error' || error.type === 'validation_error') {
      setErrorMessage(error.message);
    } else {
      setErrorMessage('An unexpected error occured.');
    }

    setIsLoading(false);
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      {errorMessage && (
        <div className="notice notice--red">
          <div className="notice__message">
            <div className="u--text-align-center-md-max">{errorMessage}</div>
          </div>
        </div>
      )}
      {totalCost > 0 && <PaymentElement id="payment-element" />}
      <div className="payment-form__order-total">Total: ${totalCost}</div>
      <button
        className="btn btn--blue"
        disabled={isLoading || !stripe || !elements}
        id="submit"
      >
        <span id="button-text">{isLoading ? 'Processing' : 'Submit'}</span>
      </button>
    </form>
  );
}

function CheckOutFieldsFree({
  formData,
  totalCost,
  paidPlan,
  coupon,
  couponError
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(couponError);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);

    let filesList = [];
    if (formData.file !== '') filesList.push(formData.file);
    if (formData.image !== '') filesList.push(formData.image);

    // Remove files for Event Post creation, files handled individual later
    formData.image = '';
    formData.file = '';

    // Add Pain Plan meta to post for Featured Event Cron
    formData.paidPlan = paidPlan;

    formData.coupon = coupon;

    // Save the form meta
    const postID = await $.ajax({
      type: 'POST',
      url: `${AJAX_URL}post_wlSubmitEvent`,
      dataType: 'json',
      encode: true,
      data: formData,
      contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
    })
      .then((r) => {
        return r.data;
      })
      .catch((err) => console.log(err.message));

    const validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];

    // Save files to ACF & Media Library
    let error;
    let indexCount = 0;
    if (filesList.length > 0) {
      filesList.forEach(async (file) => {
        if (file instanceof File) {
          let acfField;
          if (!validImageTypes.includes(file.type)) {
            acfField = 'event_file_attachment';
          } else {
            acfField = 'event_image';
          }

          let formData = new FormData();
          formData.append('content', 'filename');
          formData.append('source', file);
          formData.append('postID', postID);
          formData.append('acf-field', acfField);

          await $.ajax({
            type: 'POST',
            url: `${AJAX_URL}post_wlSubmitEventFiles`,
            data: formData,
            contentType: false,
            processData: false
          })
            .then((r) => {
              indexCount++;
              console.log(indexCount);
              console.log(filesList.length);
              if (indexCount >= filesList.length) {
                window.location.href = `${SITE_URL}/events/submit-event/thank-you?post_id=${postID}`;
              }
            })
            .catch((err) => err.message);
        }
      });
    } else {
      window.location.href = `${SITE_URL}/events/submit-event/thank-you?post_id=${postID}`;
    }

    if (error.type === 'card_error' || error.type === 'validation_error') {
      setErrorMessage(error.message);
    } else {
      setErrorMessage('An unexpected error occured.');
    }

    setIsLoading(false);
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      {errorMessage && (
        <div className="notice notice--red">
          <div className="notice__message">
            <div className="u--text-align-center-md-max">{errorMessage}</div>
          </div>
        </div>
      )}
      <div className="payment-form__order-total">Total: ${totalCost}</div>
      <button className="btn btn--blue" disabled={isLoading} id="submit">
        <span id="button-text">{isLoading ? 'Processing' : 'Submit'}</span>
      </button>
    </form>
  );
}
